import { Form, Input } from "decorator-form";
import InputType from "../../common/form/InputType";

@Form({title: "Seat Assignment Panel config"})
export default class SeatAssignmentConfig{
    @Input({type: InputType.TEXT, title: "fontSize"})
    public textSize : string="23px";
}


// WEBPACK FOOTER //
// ./src/panels/checkout/SeatAssignmentConfig.ts